export const ExternalLink = (props: Omit<React.ComponentProps<'a'>, 'rel' | 'target'>) => (
  <a rel='noreferrer' target='_blank' {...props} />
);
